export default __webpack_public_path__ + "static/media/study-materials-icon.c2986ad3.svg";